<template>
    <section class="booking-wrapper">
        <div class="container">
            <div class="columns booking-columns" style="margin-top: 0">
                <div class="column is-4">
                    <booking-calendar class="is-marginless" :employee="employee" v-model="selected_date"></booking-calendar>
                </div>
                <div class="column is-8 hourly-column">
                    <booking-hourly-ranges :reload="reload" @fetched="reload = false" :employee="employee" @selected="assignRange" :date="selected_date"></booking-hourly-ranges>
                </div>
            </div>
            <div class="booking-person">
                <div class="columns is-vcentered is-multiline">
                    <div class="column is-half-widescreen is-full">
                        <slot name="person"></slot>
                    </div>
                    <div class="column is-half-widescreen is-full">
                        <div v-if="loading" class="calendar-loader has-text-centered"><i class="fas fa-spin fa-circle-notch fa-3x"></i></div>

                        <div v-if="! success && ! loading" class="booking-form">
                            <h4><span v-html="lang('Prenota il tuo appuntamento<br>per essere ricontattato.')"></span></h4>
                            <div class="columns">
                                <div class="column is-half">
                                    <input-field :label="lang('Nome')" name="firstname"
                                                 v-model="input.firstname" :errors="formErrors"
                                                 required></input-field>
                                </div>
                                <div class="column is-half">
                                    <input-field :label="lang('Cognome')" name="lastname"
                                                 v-model="input.lastname" :errors="formErrors"
                                                 required></input-field>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column is-half">
                                    <input-field :label="lang('Indirizzo Email')" name="email"
                                                 v-model="input.email" :errors="formErrors" type="email"
                                                 required></input-field>
                                </div>
                                <div class="column is-half">
                                    <input-field :label="lang('Telefono')" name="phone"
                                                 v-model="input.phone" :errors="formErrors"
                                                 required></input-field>
                                </div>
                            </div>
                            <input-field :label="lang('Contatto skype')" name="skype"
                                         v-model="input.skype" :errors="formErrors"
                                         required></input-field>
                            <div class="field">
                                <checkbox name="privacy" v-model="input.privacy" :errors="formErrors"> Accetto <a target="_blank" href="/policies/privacy">l'informativa della privacy</a></checkbox>
                            </div>
                            <div class="field">
                                <ul class="todo has-text-grey">
                                    <li>
                                        <span class="icon" :class="{ 'has-text-success': selected_date !== '','has-text-warning': selected_date === ''  }">
                                            <i class="fas" :class="{ 'fa-check-circle': selected_date !== '','fa-exclamation-triangle': selected_date === ''  }"></i>
                                        </span>
                                        {{ lang('Seleziona giorno') }} <span v-if="selected_date">- <span v-text="selected_date.format('DD/MM/YYYY')"></span></span>
                                    </li>
                                    <li>
                                        <span class="icon" :class="{ 'has-text-success': selected_range !== '','has-text-warning': selected_range === ''  }">
                                            <i class="fas" :class="{ 'fa-check-circle': selected_range !== '','fa-exclamation-triangle': selected_range === ''  }"></i>
                                        </span>
                                        {{ lang('Seleziona fascia oraria') }} <span v-if="selected_range">- <span v-text="selected_range.name"></span></span>
                                    </li>
                                </ul>
                            </div>
                            <div class="field has-text-centered">
                                <button @click.prevent="sendForm" :disabled="! enableForm"
                                        :class="{ 'is-dark': ! enableForm, 'is-primary': enableForm }"
                                        class="button is-small" v-text="lang('Prenota Appuntamento')"></button>
                            </div>
                        </div>

                        <div v-if="success && !loading" class="booking-form">
                            <h4 v-text="lang('Grazie')"></h4>
                            <p v-text="lang('Grazie per aver prenotato un\'appuntamento con un nostro consultente.')"></p>
                            <p v-text="lang('Ti ricordiamo che il nostro consulente ti contatterà nella fascia oraria da te selezionata.')"></p>
                        </div>

                        <div v-if="errors && !loading" class="error">
                            <p class="error" v-for="error in errors" v-text="error.message"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import moment from 'moment'
    import axios from 'axios'
    import FormErrors from "../Classes/FormErrors";

    export default {
        props: {
            date: {
                type: String,
                required: true
            },
            employee: {
                type: Object,
                required: true
            }
        },
        created() {
            this.selected_date = moment.unix( this.date )
        },
        data() {
            return {
                selected_date: '',
                selected_range: '',
                form: false,
                input: {
                    firstname: '',
                    lastname: '',
                    email: '',
                    phone: '',
                    skype: '',
                    privacy: false
                },
                success: false,
                errors: false,
                formErrors: new FormErrors(),
                reload: false,
                loading: false
            }
        },
        methods: {
            assignRange( range ) {
                this.selected_range = range
            },
            sendForm() {
                this.input.selected_date = this.selected_date;
                this.input.selected_range = this.selected_range;
                this.loading = true;
                axios.post( '/calendar/api/'+this.employee.id+'/book', this.input)
                    .then( response => {
                        this.success = true;
                        this.reload = true;
                        this.loading = false;
                    })
                    .catch( error => {
                        this.reload = true;
                        this.loading = false;
                        if( error.response.status === 422 ) return this.formErrors.record( error.response.data.errors )
                        this.errors = error.response.data;
                    } )
            }
        },
        computed: {
            enableForm() {
                return ( this.selected_date !== '' && this.selected_range !== '' )
            }
        }
    }
</script>